import Vue from 'vue';
import config from 'config';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { loggedInUser } from '@mobile/services/user';
import { eventBus } from '@/eventBus';
import { version } from '@mobile/../package.json';

export default function init() {
    if (config.environment !== 'production') return;

    Sentry.init({
        dsn: 'https://5190b38a289b496882d099b928db6610@sentry.io/1528461',
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
        release: `MOBILE-${version}`,
    });

    const user = loggedInUser();
    if (user) configureSentryScope(user);

    eventBus.$on('login', configureSentryScope);
    eventBus.$on('logout', resetSentryScope);
}


function configureSentryScope(user) {
    Sentry.configureScope((scope) => {
        scope.setUser({
            id: user.id,
            email: user.email,
        });
        if (user.locale) {
            scope.setTag('page_locale', user.locale);
        }
    });
}

function resetSentryScope() {
    Sentry.configureScope((scope) => {
        scope.setUser({
            id: null,
            email: null,
        });
        scope.setTag('page_locale', 'en');
    });
}
